module.exports = __webpack_public_path__ + "img/menu_icon11.cee1bc01.png";